import classNames from 'classnames';
import React from 'react';

import AnchorLink from '@jpp/atoms/AnchorLink';
import Icons from '@jpp/atoms/Icon';
import Container from '@jpp/shared/Grid/Container';
import Flex from '@jpp/shared/Grid/Flex';
import Row from '@jpp/shared/Grid/Row';
import Section from '@jpp/shared/Grid/Section';

import './BackTo.scss';

interface IBackToProps {
  className?: string;
  href: string;
  label: string;
}

const ROOT_CLASSNAME = 'BackTo';

const BackTo: React.FunctionComponent<IBackToProps> = ({
  className,
  href,
  label,
}) => (
  <Section
    className={classNames(ROOT_CLASSNAME, className)}
    withPadding={false}
  >
    <Container className={`${ROOT_CLASSNAME}__container`} fluid={true}>
      <Row>
        <Flex>
          <AnchorLink className={`${ROOT_CLASSNAME}__link`} href={href}>
            <Icons.Arrow className={`${ROOT_CLASSNAME}__icon`} />{' '}
            {`Back to ${label}`}
          </AnchorLink>
        </Flex>
      </Row>
    </Container>
  </Section>
);

export default BackTo;
